import React from 'react';
import { Link } from 'react-router-dom';
import { Scale, Mail, MessageCircle, Book, FileText } from 'lucide-react';
import ContactFormBox from '../components/ContactFormBox';
import CanonicalURL from '../components/CanonicalURL';
import './HelpPage.css';

const LegalPage = () => {
  return (
    <>
      <CanonicalURL url="https://wealthcore.app/legal" />
      <div className="help-page">
        <section className="help-hero">
          <div className="help-container">
            <div className="help-hero-content">
              <Scale className="help-hero-icon" />
              <h1 className="help-title">Legal</h1>
              <p className="help-subtitle">
                Legal inquiries and questions about WealthCore
              </p>
            </div>
          </div>
        </section>

        <section className="help-section">
          <div className="help-container">
            <div className="help-content-grid">
              <div className="help-contact-form-wrapper">
                <ContactFormBox
                  title="Legal Questions"
                  subtitle="Have a legal question or inquiry about WealthCore? Send us a message and we'll get back to you as soon as possible."
                  fixedSubject="Legal"
                />
              </div>

              <div className="help-sidebar">
                <div className="help-info-card">
                  <h3 className="help-info-title">Get in Touch</h3>
                  <div className="help-info-item">
                    <Mail className="help-info-icon" />
                    <div>
                      <strong>Email</strong>
                      <p><Link to="/help#contact-form" className="text-blue-600 hover:underline">support@wealthcore.app</Link></p>
                    </div>
                  </div>
                  <div className="help-info-item">
                    <MessageCircle className="help-info-icon" />
                    <div>
                      <strong>Response Time</strong>
                      <p>Within 24 hours</p>
                    </div>
                  </div>
                  <div className="help-info-item">
                    <Book className="help-info-icon" />
                    <div>
                      <strong>Related</strong>
                      <p><Link to="/terms" className="text-blue-600 hover:underline">Terms of Service</Link></p>
                      <p><Link to="/privacy" className="text-blue-600 hover:underline">Privacy Policy</Link></p>
                    </div>
                  </div>
                </div>

                <div className="help-quick-links">
                  <h3 className="help-info-title">Quick Links</h3>
                  <Link to="/terms" className="help-quick-link">
                    <FileText className="help-link-icon" />
                    Terms of Service
                  </Link>
                  <Link to="/privacy" className="help-quick-link">
                    <FileText className="help-link-icon" />
                    Privacy Policy
                  </Link>
                  <Link to="/help" className="help-quick-link">
                    <FileText className="help-link-icon" />
                    Help & Support
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default LegalPage;
